import { makeStyles } from '@rbx/ui';

const useMarkdownBlockQuoteStyles = makeStyles()((theme) => ({
  outerContainer: {
    padding: theme.spacing(3),
  },

  innerContainer: {
    paddingLeft: theme.spacing(3),
    borderLeftStyle: 'solid',
    borderLeftWidth: '2px',
    borderLeftColor: theme.palette.components.divider,
  },

  typographyContainer: {
    marginBottom: '-16px', // countering the default margin of the paragraph element
  },
}));

export default useMarkdownBlockQuoteStyles;
